import classNames from "classnames";
import styles from "./FJResourcesElementSearch.module.less";
import FJLocalStore from "../../../store/FJLocalStore";
import InlineSVG from "react-inlinesvg";
import deleteSvg from "../../../icon/delete-resource.svg";
import FJButton from "fj-components/FJButton";
import React from "react";

function FJElementSearchHistory(props) {

  let {
    history,
    popularList,
    isShow,
    onSearch,
    clareHistory
  } = props;

  return (
    <div className={classNames(styles.search_history_container, {[styles.active]: isShow})}
         onMouseDown={(e) => {
           e.preventDefault();
           e.stopPropagation();
         }}>
      <div className={styles.history_frame}>
        {
          history.length > 0 ? (
            <div className={styles.history_info}>
              <span className={styles.info_box}>{FJLocalStore._('search history')}</span>
              <div className={styles.clear_history}
                   onClick={clareHistory}>
                <InlineSVG src={deleteSvg}/>
              </div>
            </div>
          ) : null
        }
        <div className={styles.list_box}>
          {createTriggers(history, styles, onSearch)}
        </div>
        <div className={styles.history_info}>
          <span className={styles.info_box}>{FJLocalStore._('popular')}</span>
        </div>
        <div className={styles.list_box}>
          {createTriggers(popularList, styles, onSearch)}
        </div>
      </div>
    </div>
  )
}

function createTriggers(list, styles, onSearch) {
  return list.map((item) => {
    return (
      <FJButton key={item}
                text={item}
                className={styles.keywords_item}
                textClass={styles.keywords_text}
                onClick={() => {
                  onSearch(item)
                }}/>
    );
  })
}

export default FJElementSearchHistory;